import columnsMessages from 'govbr.frontend.policy/messages/columns';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  labelColumn: {
    id: 'Column',
    defaultMessage: 'Column',
  },
  labelDefault: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  labelColumnTitle: {
    id: 'Column title',
    defaultMessage: 'Column title',
  },
  labelColumnsBlock: {
    id: 'Columns block',
    defaultMessage: 'Columns block',
  },
  labelTitle: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  descrTitle: {
    id: 'Columns block friendly name',
    defaultMessage: 'Columns block friendly name',
  },
  labelColumns: {
    id: 'Columns',
    defaultMessage: 'Columns',
  },
  labelLayout: {
    id: 'Layout',
    defaultMessage: 'Layout',
  },
  labelReverseWrap: {
    id: 'Reverse wrap',
    defaultMessage: 'Reverse wrap',
  },
  reverseWrapDescription: {
    id: 'reverseWrapDescription',
    defaultMessage: 'Reverse column order when opening site on mobile.',
  },
});

export const ColumnSchema = (intl) => ({
  title: intl.formatMessage(messages.labelColumn),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.labelDefault),
      fields: ['column_title'],
    },
  ],
  properties: {
    column_title: {
      title: intl.formatMessage(messages.labelColumnTitle),
    },
  },
  required: [],
});

export const ColumnsBlockSchema = (intl) => ({
  title: intl.formatMessage(messages.labelColumnsBlock),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.labelDefault),
      fields: [
        'title',
        'data',
        'gridCols',
        'fullWidth',
        'useBackground',
        'backgroundColor',
        'increasePadding',
        'reverseWrap',
      ],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.labelTitle),
      description: intl.formatMessage(messages.descrTitle),
      type: 'string',
    },
    data: {
      title: intl.formatMessage(messages.labelColumns),
      type: 'columns',
      schema: ColumnSchema(intl),
      maxSize: 6,
    },
    gridCols: {
      title: intl.formatMessage(messages.labelLayout),
      widget: 'layout_select',
      choices: [],
    },
    reverseWrap: {
      title: intl.formatMessage(messages.labelReverseWrap),
      description: intl.formatMessage(messages.reverseWrapDescription),
      type: 'boolean',
    },
    useBackground: {
      title: intl.formatMessage(columnsMessages.useBackground),
      type: 'boolean',
    },
    backgroundColor: {
      title: intl.formatMessage(columnsMessages.backgroundColor),
      widget: 'color_picker',
      default: 'grey',
      type: 'string',
      colors: [
        {
          name: 'grey',
          label: intl.formatMessage(columnsMessages.grey),
        },
        {
          name: 'darkBlue',
          label: intl.formatMessage(columnsMessages.darkBlue),
        },
      ],
    },
    increasePadding: {
      title: intl.formatMessage(columnsMessages.increasePadding),
      type: 'boolean',
    },
    fullWidth: {
      title: intl.formatMessage(columnsMessages.fullWidth),
      required: true,
      noValueOption: false,
      default: 'none',
      type: 'string',
      factory: 'Choice',
      choices: [
        ['none', intl.formatMessage(columnsMessages.none)],
        ['background', intl.formatMessage(columnsMessages.background)],
        ['all', intl.formatMessage(columnsMessages.contentAndBackground)],
      ],
    },
  },
  required: [],
});

export const schemaExtender = (schema, data) => {
  const showBackgroundColor = !!data?.useBackground;
  const defaultFieldset = schema.fieldsets.find(
    (fieldset) => fieldset.id === 'default',
  );

  if (!defaultFieldset) {
    return schema;
  }

  const baseFields = defaultFieldset.fields.filter(
    (field) => field !== 'backgroundColor',
  );

  if (showBackgroundColor) {
    const useBackgroundIndex = baseFields.indexOf('useBackground');

    if (useBackgroundIndex >= 0) {
      baseFields.splice(useBackgroundIndex + 1, 0, 'backgroundColor');
    } else {
      baseFields.push('backgroundColor');
    }
  }

  defaultFieldset.fields = baseFields;
  return schema;
};
